<!-- version 2021/05/20 -->
<template>
    <div class="d-flex">
        <app-label-text class="title mb-0" :title="title"></app-label-text>
        <div class="d-flex-colomn w-100">
            <div class="d-flex">
                <div class="d-flex w-50">
                    <app-label-text class="mb-0 mr-2" :title="label1"></app-label-text>
                    <app-normal-text :text="text1"></app-normal-text>
                </div>
                <div class="content-detail d-flex w-50">
                    <app-label-text class="mb-0 mr-2" :title="label2"></app-label-text>
                    <app-normal-text :text="text2"></app-normal-text>
                </div>
            </div>
            <hr>
            <div class="d-flex">
                <div class="d-flex w-50">
                    <app-label-text class="mb-0 mr-2" :title="label3"></app-label-text>
                    <app-normal-text :text="text3"></app-normal-text>
                </div>
                <div class="content-detail d-flex w-50">
                    <app-label-text class="mb-0 mr-2" :title="label4"></app-label-text>
                    <app-normal-text :text="text4"></app-normal-text>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            label1: String,
            text1: String,
            label2: String,
            text2: String,
            label3: String,
            text3: String,
            label4: String,
            text4: String
        }
    }
</script>

<style lang="sass" scoped>
    .content-detail
        padding-left: 12px
    .title
        min-width: 120px
</style>